import { FC, useEffect } from 'react';
import { IContactMethod, IContactMethodType } from '../caremap/ICareMap';
import { TextField } from '../components/TextField';
import { EmailValidator } from '../utils/EmailValidator';

export interface IEmailContactMethod extends Omit<IContactMethod, 'type'> {
    type: Exclude<IContactMethodType, 'mobile-phone' | 'work-phone'>
};

type IEmailFieldProps = {
    method: IEmailContactMethod;
    //autoFocus?: boolean;
    methodChanged: (method: IContactMethod) => void;
    isValid?: (valid: boolean) => void;
    required?: boolean;
    'data-id'?: string;
};

export const EmailField: FC<IEmailFieldProps> = ({ method, methodChanged, isValid, required = false, 'data-id': dataId }) => {
    const validate = (value: string) => {
        if (isValid) {
            isValid(EmailValidator.test(value));
        }
    };

    // validate on load
    useEffect(() => {
        validate(method?.value || '');
    }, [method.value]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!method) {
        return null;
    }

    const valueChanged = (value: string) => {
        methodChanged({ ...method, value });
        validate(value);
    };

    return (
        <TextField
            //autoFocus={autoFocus}
            name="email-field"
            label="Email"
            data-id={dataId}
            placeholder="name@example.com"
            value={method.value}
            required={required}
            autocapitalize="none"
            onInput={valueChanged}
        />
    );
};
